exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#mc_embed_signup form {\n  padding: 0; }\n\n#mc_embed_signup h2 {\n  padding: 10px 20px 15px 50px;\n  margin: 0 0 20px -50px;\n  font-size: 2rem; }\n\n.signup-text {\n  margin: 0; }\n\n.indicates-required {\n  margin: -5px 0; }\n\n.mc-field-group {\n  padding: 0 0 10px !important; }\n\n.btn-primary {\n  margin: 10px 0 0 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/login-module/wait-list/wait-list.component.scss
// module id = ../../../../../src/app/login-module/wait-list/wait-list.component.scss
// module chunks = main